import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=5190a6a2&scoped=true&"
import script from "./NewProduct.vue?vue&type=script&lang=ts&"
export * from "./NewProduct.vue?vue&type=script&lang=ts&"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=5190a6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190a6a2",
  null
  
)

export default component.exports